query StreamEntrypointsList($page: Int, $rowsPerPage: Int, $search: String) {
  streamEntrypoints(page: $page, rowsPerPage: $rowsPerPage, search: $search) {
    count
    nodes {
      id
      title
      rtmpsUrl
      liveConnected
      stream {
        id
        title
      }
      createdAt
    }
  }
}
